import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { PricingClient } from 'src/WebApiController';

export const useEventMapConfigMetadata = (viagogoEventId: number | null) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const shouldQuery =
    viagogoEventId != null &&
    activeAccountWebClientConfig?.activeAccountId != null;

  const queryKey = ['PricingClient.GetEventMapConfigMetadata', viagogoEventId];

  const eventMapConfigQuery = useQuery({
    queryKey,
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }

      return await new PricingClient(
        activeAccountWebClientConfig
      ).getEventMapConfigMetadata(viagogoEventId!);
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        showErrorDialog('PricingClient.GetEventMapConfigMetadata', error, {
          trackErrorData: {
            viagogoEventId,
          },
        });
      },
    },
  });

  return {
    queryKey,
    eventMapConfigQuery,
  };
};
